import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BsFileEarmarkPdf } from "react-icons/bs";
import { RiFileExcel2Line } from "react-icons/ri";

const VehiclesToComeToReturns = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [date, setDate] = useState(new Date().toISOString());
  const [vehicleNo, setVehicleNo] = useState("");
  const [driver, setDriver] = useState("");
  const [previousTripNo, setPreviousTripNo] = useState("");
  const [clientsList, setClientsList] = useState([]);
  const [returnsClient, setreturnsClient] = useState("");
  const [returnsClientCode, setReturnsClientCode] = useState("");
  const [returnsProduct, setReturnsProduct] = useState("");
  const [returnsProductCode, setReturnsProductCode] = useState("");
  const [productsList, setProductsList] = useState([]);
  const [returnsQty, setReturnsQty] = useState("");
  const [specification, setSpecification] = useState("");
  const [returnsReason, setReturnsReason] = useState("");
  const [returnNo, setReturnNo] = useState("");
  const [latestReturnNo, setLatestReturnNo] = useState("");
  const [firstReturnNo, setFirstReturnNo] = useState("");
  const [actionTaken, setActionTaken] = useState("");
  const [milageIssued, setMileageIssued] = useState("");
  const [mileageAmount, setMileageAmount] = useState("");
  const [driversList, setDriversList] = useState([]);
  const [uom, setUom] = useState("");
  const [uomList, setUomList] = useState([]);
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [tableData, setTableData] = useState([]); // All products prefilled
  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString(),
  );

  const [proceedToState, setProceedToState] = useState("");
  const [proceedToStateValue, setProceedToStateValue] = useState("");
  const [wbData, setWbData] = useState([]);
  const [wbName, setWbName] = useState("");
  const [wbNo, setWbNo] = useState("");
  const [WeighBridgeData, setWeighBridgeData] = useState([]);
  const [noOfVehicles, setNoOfVehicles] = useState("");

  const [returnActionData, setReturnActionData] = useState([]);
  const [returnReasonData, setReturnReasonData] = useState([]);

  const [histData, setHistData] = useState([]);
  const [showHist, setShowhist] = useState(false);
  const [searchHist, setSearchHist] = useState("");
  const [startDateHist, setStartDateHist] = useState("");
  const [endDateHist, setEndDateHist] = useState("");
  const [searchChild, setSearchChild] = useState("");
  const [selProduct, setSelProduct] = useState("");
  const [driverCode, setDriverCode] = useState("");
  const [hist, setHist] = useState(false);

  // Filter Products
  const filtProd = productsList?.filter((item) => {
    const searchData = searchChild?.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0 && !selProduct) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["MAINNAME"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const prodFilter = !selProduct || item?.MAINNAME === selProduct;

    return textMatch && prodFilter;
  });

  // Filtered Hist Data
  const filtHist = histData?.filter((item) => {
    const searchData = searchHist?.toLowerCase().split(" ").filter(Boolean);
    const sDate = new Date(item.OT_RETURN_DATE);
    const eDate = new Date(item.OT_RETURN_DATE);
    const startDate = startDateHist ? new Date(startDateHist) : null;
    const endDate = endDateHist ? new Date(endDateHist) : null;

    const prod = productsList?.find(
      (row) => row?.ITEMCODE === item?.["OT_RETURN_PRODUCT_CODE"],
    );

    const driver = driversList?.find(
      (row) => row?.DRIVERCODE === item?.["OT_RETURN_DRIVER_CODE"],
    );

    const textMatch = searchData.every((term) => {
      const prodMatch = prod?.MAINNAME?.toLowerCase()?.includes(term) ?? false;
      const driverMatch =
        driver?.DRIVERNAME?.toLowerCase()?.includes(term) ?? false;

      const otherMatch = [
        "OT_RETURN_NO",
        "OT_RETURN_TRUCK_NUMBER",
        "OT_RETURN_PRODUCT_QTY",
        "OT_RETURN_ACTION_TAKEN",
        "OT_RETURN_REASON",
      ].some((key) => {
        const columnValue = String(item[key] || "").toLowerCase();
        return columnValue.includes(term);
      });

      return prodMatch || driverMatch || otherMatch;
    });

    const dateMatch =
      (!startDate || sDate >= startDate) && (!endDate || eDate <= endDate);

    return textMatch && dateMatch;
  });

  const VehicleDepartment = useSelector(
    (state) => state?.VehicleDepartmentReducer,
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (productsList?.length) {
      setTableData(
        productsList.map((item) => ({
          ITEMCODE: item.ITEMCODE,
          qty: "",
          uom: "",
          actionTaken: "",
          reason: "",
          isSelected: false,
        })),
      );
    }
  }, [productsList]);

  const filteredData = vehiclesList.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "VEHICLE REG NO",
        "DRIVERNAME",
        "MAKE",
        "MODEL",
        "TRAILER NAME ATTACHED",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1077`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setReturnNo(response?.data[0]?.NEW_RETURN_NO);
        setLatestReturnNo(response?.data[0]?.NEW_RETURN_NO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });

    // Client's List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=599`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setClientsList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Client Details:", error);
      });

    //   Items List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=625`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) =>
            item.OM_ITEM_FINISHED_RAW_MATERIAL === "F" &&
            item?.DEPARTMENT === "LOGISTICS",
        );
        setProductsList(filter);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Item Details:", error);
      });

    // axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1060`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then((response) => {
    //     const filterData = response?.data?.filter(
    //       (item) =>
    //         item.OT_VERIFICATION_PROCEED_TO_STATE === "SENT FOR WEIGHBRIDGE",
    //     );
    //     setWeighBridgeData(filterData);
    //   })
    //   .catch((error) => {
    //     setisloading(false);
    //     console.error("Error fetching Driver details:", error);
    //   });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1264`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setWbData(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching WeighBridge details:", error);
      });

    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriversList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    // Driver's List  669;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=669`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setUomList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details: 669", error);
      });

    // Actions Master data
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1327`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setReturnActionData(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Return Action details:", error);
      });

    // Reason Master data
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1324`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setReturnReasonData(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Return Reason details:", error);
      });

    // History data - 1078
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1078`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const sortedData = response?.data?.sort(
          (a, b) => a?.OT_RETURN_NO - b?.OT_RETURN_NO,
        );
        setHistData(sortedData);
        setFirstReturnNo(sortedData[0]?.OT_RETURN_NO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching 1078 details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        if (VehicleDepartment !== "") {
          const filterData = response?.data?.filter(
            (item) =>
              item.VEHICLESTATE === "SENT FOR RETURNS" &&
              item?.DEPARTMENT === VehicleDepartment,
          );
          if (filterData?.length === 0) {
            setShowGateIn(true);
          }
          setVehiclesList(filterData);
          const filterWeighbridge = response?.data?.filter(
            (item) =>
              item.VEHICLESTATE === "SENT FOR WEIGHBRIDGE" &&
              item?.DEPARTMENT === VehicleDepartment,
          );
          setWeighBridgeData(filterWeighbridge);
        } else {
          const filterData = response?.data?.filter(
            (item) => item.VEHICLESTATE === "SENT FOR RETURNS",
          );
          if (filterData?.length === 0) {
            setShowGateIn(true);
          }
          setVehiclesList(filterData);
          const filterWeighbridge = response?.data?.filter(
            (item) => item.VEHICLESTATE === "SENT FOR WEIGHBRIDGE",
          );
          setWeighBridgeData(filterWeighbridge);
        }
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });
  };

  function fetchVerificationHeadData(vehicle) {
    //   For Last Gate In No
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1060`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) =>
            item.OT_VERIFICATION_VEHICLE === vehicle &&
            item.OT_VERIFICATION_PROCEED_TO_STATE === "SENT FOR RETURNS",
        );
        // setTableData(filter);

        setReturnsClientCode(
          filter[filter?.length - 1]?.OT_VERIFICATION_RETURNS_CLIENT,
        );

        const client = clientsList.find(
          (item) =>
            item.CLIENTCODE ===
            filter[filter?.length - 1]?.OT_VERIFICATION_RETURNS_CLIENT,
        );
        setreturnsClient(client?.CLIENTNAME);

        // const product = productsList.find(
        //   (item) =>
        //     item.ITEMCODE ===
        //     filter[filter?.length - 1]?.OT_VERIFICATION_RETURNS_PRODUCT
        // );
        // setReturnsProduct(product?.MAINNAME);
        setPreviousTripNo(
          filter[filter?.length - 1]?.OT_VERIFICATION_PREVIOUS_TRIP_NO,
        );
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Verification Data:", error);
      });
  }

  async function getNewReturnNo() {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1077`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setReturnNo(response?.data[0]?.NEW_RETURN_NO);
        setLatestReturnNo(response?.data[0]?.NEW_RETURN_NO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Charges details:", error);
      });
  }

  // Saving

  async function SaveHeader() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1445`,
        {
          OT_RETURN_NO: Number(returnNo),
          OT_RETURN_TRUCK_NUMBER: vehicleNo ? vehicleNo : "",
          OT_RETURN_DATE: moment(date).format("YYYY/MM/DD"),
          OT_RETURN_PROCESSED_BY: user,
          OT_RETURN_NEW_EXISTING: hist === true ? "EXISTING" : "NEW",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        console.log(`Vehicle Gate Out successfully`);
        console.log(response?.data?.message);
        await SaveGateIn(response?.data?.message);
      } else {
        alert(`Error while Saving Return To Customer`);
        setisloading(false);
        console.error(`Error while Saving Return To Customer`);
      }
    } catch (error) {
      alert(`Error while Saving Return To Customer`, error);
      setisloading(false);
      console.error(`Error while Saving Return To Customer`, error);
    }
  }

  async function SaveGateIn(docNo) {
    setisloading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    const selectedRows = tableData?.filter((row) => row.isSelected);
    for (let i = 0; i < selectedRows.length; i++) {
      const value = selectedRows[i];
      try {
        const response = await axios.post(
          `${BASEURL_GLOBAL}/globalSpHandler?spname=1079`,
          {
            OT_RETURN_NO: Number(docNo),
            OT_RETURN_DATE: moment(date).format("YYYY/MM/DD"),
            OT_RETURN_TIME: currentTime,
            OT_RETURN_FROM_TRIP_NO: 1,
            OT_RETURN_CLIENT_CODE: returnsClientCode ? returnsClientCode : "",
            OT_RETURN_PRODUCT_CODE: value?.code ? value?.code : "",
            OT_RETURN_PRODUCT_QTY: value?.qty ? Number(value?.qty) : 0,
            OT_RETURN_PRODUCT_QTY_UOM: value?.uom ? value?.uom : "",
            OT_RETURN_REASON: value?.reason ? value?.reason : "",
            OT_RETURN_ACTION_TAKEN: value?.actionTaken
              ? value?.actionTaken
              : "",
            OT_RETURN_MILEAGE_ISSUED: 0,
            OT_RETURN_MILEAGE_AMOUNT: 0,
            OT_RETURN_NEXT_STATE: "PROCEED TO SECURITY DEPARTMENT",
            OT_RETURN_TRUCK_NUMBER: vehicleNo,
            OT_RETURN_PROCESSED_BY: user,
            OT_RETURN_PROCEED_TO_WEIGHBRIDGE_NO: wbNo ? Number(wbNo) : 0,
            OT_RETURN_PROCEED_TO_STATE: proceedToStateValue,
            OT_RETURN_DRIVER_CODE: driverCode,
            OT_RETURN_NEW_EXISTING: "NEW",
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessionToken,
            },
          },
        );

        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      } catch (error) {
        console.error(`Error while Saving Loose Cargo Details `, error);
        alert(error.response.data.message);
        setisloading(false);
      }
    }
    if (successCount == selectedRows.length && successMessage) {
      await SaveVehicleState(docNo);
    }
    if (errorMessage) {
      //  alert(errorMessage);
      alert("Error while returning");
      setisloading(false);
    }
  }

  async function SaveVehicleState(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNo,
          OT_VEHICLE_STATE: proceedToStateValue
            ? proceedToStateValue
            : "PROCEED TO SECURITY DEPARTMENT",
          OT_VEHICLE_STATE_DATE: moment(date).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: currentTime,
          OT_VEHICLE_PREVIOUS_STATE: "SENT FOR RETURNS",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        await SaveState(docNo);
        console.log(`Vehicle State Updated successfully`);
      } else {
        console.error(`Error while saving Vehicle State`);
        alert(`Error while saving Vehicle State`);
        setisloading(false);
      }
    } catch (error) {
      console.error(`Error while saving Vehicle State `, error);
      alert(`Error while saving Vehicle State `, error);
      setisloading(false);
    }
  }

  async function SaveState(docNo) {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1121`,
        {
          TRANSTYPE: "PROCEED TO SECURITY DEPARTMENT",
          DOC_NO: Number(docNo),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        },
      );

      if (response.status === 201) {
        alert("Returned successfully");
        console.log(`State Updated successfully`);
        setisloading(false);
      } else {
        console.error(`Error while saving State`);
        alert(`Error while saving State`);
        setisloading(false);
      }
    } catch (error) {
      console.error(`Error while saving State `, error);
      alert(`Error while saving State `, error);
      setisloading(false);
    }
  }

  const handleRowClick = (value, index) => {
    setDriver(value["DRIVERNAME"]);
    const driver = driversList?.find(
      (row) => row?.DRIVERNAME === value?.["DRIVERNAME"],
    );
    setDriverCode(driver?.DRIVERCODE);
    setVehicleNo(value["VEHICLE REG NO"]);
    fetchVerificationHeadData(value["VEHICLE REG NO"]);
    setShowGateIn(true);
  };

  // const updateTableField = (index, field, value) => {
  //   setTableData((prev) => {
  //     const updated = [...prev];
  //     updated[index][field] = value;
  //     return updated;
  //   });
  // };

  // const updateTableField = (itemCode, field, value) => {
  //   console.log(itemCode,field,value)
  //   setTableData((prev) =>
  //     prev.map((row) =>
  //       row.ITEMCODE === itemCode ? { ...row, [field]: value } : row,
  //     ),
  //   );
  // };

  const updateTableField = (itemCode, field, value) => {
    setTableData((prev) =>
      prev.map((row) =>
        String(row.ITEMCODE) === String(itemCode)
          ? { ...row, [field]: value }
          : row,
      ),
    );
  };

  const handleRowCheck = (itemCode, checked) => {
    updateTableField(itemCode, "isSelected", checked);
  };

  const ExcelStockData = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Vehicles To Come To Returns");
    const rows = document.querySelectorAll(".table_1 tbody tr");

    const columnWidths = [15, 15, 15, 15, 15, 50];

    // Set column widths for the worksheet
    columnWidths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });

    // Add headers
    const headerRow = worksheet.addRow([
      "JOB ID",
      "VEHICLE",
      "DATE",
      "TIME",
      "LOADED/EMPTY",
      "PROBLEMS REPORTED",
    ]);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Add rows from the table
    rows.forEach((row) => {
      const rowData = [];
      row.querySelectorAll("td").forEach((cell) => {
        rowData.push(cell.textContent);
      });
      worksheet.addRow(rowData);
    });

    // Create a blob from the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Vehicles_To_Come_To_Returns.xlsx";
      link.click();
    });
  };

  const PdfStockData = () => {
    const doc = new jsPDF();

    doc.text("Vehicles To Come To Returns - Report", 10, 10);

    const columns = [
      "RETURN NO",
      "VEHICLE",
      "DATE",
      "TIME",
      "PRODUCT",
      "QTY",
      "UOM",
      "REASON",
      "ACTION TAKEN",
    ];
    const data = filtHist.map((stock) => [
      stock.OT_RETURN_NO,
      stock.OT_RETURN_TRUCK_NUMBER,
      stock.OT_RETURN_DATE
        ? moment(stock.OT_RETURN_DATE).format("DD/MM/YYYY")
        : "",
      stock.OT_RETURN_TIME
        ? moment(stock.OT_RETURN_TIME).format("hh:MM:ss")
        : "",
      stock.OT_RETURN_PRODUCT_CODE,
      stock.OT_RETURN_PRODUCT_QTY,
      stock.OT_RETURN_PRODUCT_QTY_UOM,
      stock.OT_RETURN_REASON,
      stock.OT_RETURN_ACTION_TAKEN,
    ]);

    doc.autoTable({
      head: [columns],
      body: data,
      startY: 20,
      showHead: "firstPage",
    });

    doc.save("Vehicles_To_Come_To_Returns.pdf");
  };

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Vehicles To Come To Returns
        </h1>
        {/* <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        /> */}
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MAKE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                MODEL
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                TRAILER ATTACHED ?
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                ATTACHED NAME TRAILER
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => (
              <tr
                key={index}
                className="hover:bg-gray-100 cursor-pointer text-[13px]"
                onClick={() => handleRowClick(value, index)}
              >
                <td className="py-2 px-4 text-right border border-gray-300">
                  {index + 1}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["VEHICLE REG NO"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["DRIVERNAME"] || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MAKE || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value.MODEL || "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER ATTACHED"] === true
                    ? "YES"
                    : value["TRAILER ATTACHED"] === false
                      ? "NO"
                      : "N/A"}
                </td>
                <td className="py-2 px-4 text-left border border-gray-300">
                  {value["TRAILER NAME ATTACHED"] || "N/A"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* PopUp */}
      {showGateIn && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[600px] h-[80%] lg:w-[1300px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="text-3xl font-bold flex lg:justify-center justify-start">
            RETURNS
          </h1>

          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Return No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={returnNo}
              readOnly
            ></input>

            <button
              className="border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-1 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                setShowhist(true);
              }}
            >
              ...
            </button>

            {showHist && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search:</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={searchHist}
                    onChange={(e) => {
                      setSearchHist(e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">Start Date:</p>
                  <input
                    className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={startDateHist?.split("T")[0]}
                    onChange={(e) => {
                      setStartDateHist(e.target.value);
                    }}
                  ></input>
                  <p className="text-red-600 lg:ml-2">End Date:</p>
                  <input
                    className="w-36 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="date"
                    value={endDateHist?.split("T")[0]}
                    onChange={(e) => {
                      setEndDateHist(e.target.value);
                    }}
                  ></input>
                </div>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => setShowhist(false)}
                >
                  Close
                </button>
                <div className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
                  <div className="flex justify-end gap-2">
                    <div className="cursor-pointer">
                      <RiFileExcel2Line onClick={ExcelStockData} size={25} />
                    </div>
                    <div className="cursor-pointer">
                      <BsFileEarmarkPdf onClick={PdfStockData} size={25} />
                    </div>
                  </div>

                  <table className="w-full border border-gray-300 text-sm table_1">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[12px] table-header">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Return No
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Vehicle
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Driver
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Date
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Time
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Product
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Quantity
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          UOM
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Reason
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Action Taken
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {filtHist?.map((item, index) => {
                        const prod = productsList?.find(
                          (row) =>
                            row?.ITEMCODE === item?.["OT_RETURN_PRODUCT_CODE"],
                        );

                        const driver = driversList?.find(
                          (row) =>
                            row?.DRIVERCODE === item?.["OT_RETURN_DRIVER_CODE"],
                        );

                        return (
                          <tr
                            className="hover:bg-gray-100 cursor-pointer text-[13px]"
                            onClick={() => {
                              setReturnNo(item?.["OT_RETURN_NO"]);
                              setVehicleNo(item?.["OT_RETURN_TRUCK_NUMBER"]);
                              setDate(item?.["OT_RETURN_DATE"]);
                              setCurrentTime(item?.["OT_RETURN_TIME"]);

                              setDriverCode(item?.["OT_RETURN_DRIVER_CODE"]);
                              const driver = driversList?.find(
                                (row) =>
                                  row?.DRIVERCODE ===
                                  item?.["OT_RETURN_DRIVER_CODE"],
                              );
                              setDriver(driver?.DRIVERNAME);
                              setHist(true);

                              // setLoadedOrEmpty(item?.["OT_RETURN_PRODUCT_CODE"])
                              // setProblemsReportedOP(item?.["OT_RETURN_PRODUCT_QTY"])
                              setShowhist(false);
                            }}
                            key={index}
                          >
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {item?.["OT_RETURN_NO"]
                                ? item?.["OT_RETURN_NO"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_RETURN_TRUCK_NUMBER"]
                                ? item?.["OT_RETURN_TRUCK_NUMBER"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {driver?.DRIVERNAME ? driver?.DRIVERNAME : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_RETURN_DATE"]
                                ? moment(item?.["OT_RETURN_DATE"]).format(
                                    "DD/MM/YYYY",
                                  )
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {item?.["OT_RETURN_TIME"]
                                ? moment(item?.["OT_RETURN_TIME"]).format(
                                    "hh:MM:ss",
                                  )
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 text-right border border-gray-300">
                              {prod?.MAINNAME ? prod?.MAINNAME : "NA"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300 text-right">
                              {item?.["OT_RETURN_PRODUCT_QTY"]
                                ? item?.["OT_RETURN_PRODUCT_QTY"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {item?.["OT_RETURN_PRODUCT_QTY_UOM"]
                                ? item?.["OT_RETURN_PRODUCT_QTY_UOM"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {item?.["OT_RETURN_REASON"]
                                ? item?.["OT_RETURN_REASON"]
                                : "NA"}
                            </td>
                            <td className="py-2 px-4 border border-gray-300">
                              {item?.["OT_RETURN_ACTION_TAKEN"]
                                ? item?.["OT_RETURN_ACTION_TAKEN"]
                                : "NA"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <p className="text-red-600 lg:ml-14">Previous Trip No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 mr-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={previousTripNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-20">Date :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={date?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-20">Time :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={currentTime}
              readOnly
            ></input>
          </div>

          {/* Row 2 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Vehicle :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-6 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNo}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-2 mr-1">Driver :</p>
            <Select
              className="lg:w-56 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                driver
                  ? { value: driver, label: driver }
                  : { value: "", label: "Select Driver" }
              }
              onChange={(e) => {
                setDriver(e.label);
                setDriverCode(e.value);
              }}
              options={[
                { value: "", label: "Select Driver" },
                ...driversList?.map((item) => ({
                  value: item.DRIVERCODE,
                  label: item.DRIVERNAME,
                })),
              ]}
            ></Select>

            <p className="text-red-600 lg:ml-2">Returns Client Name :</p>
            <input
              className="w-72 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={returnsClient}
              readOnly
            ></input>
          </div>

          {/* Row 3 */}

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Proceed To :</p>
            <Select
              className="lg:w-64 lg:ml-2"
              menuPortalTarget={document.body} // ⬅️ Renders dropdown at body level
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ⬅️ Forces on top
              }}
              value={
                proceedToState
                  ? { value: proceedToState, label: proceedToState }
                  : { value: "", label: "Select State" }
              }
              onChange={(e) => {
                setProceedToState(e.label);
                setProceedToStateValue(e.value);
              }}
              options={[
                { value: "", label: "Select State" },
                { value: "SENT TO WORKSHOP", label: "PROCEED TO WORKSHOP" },
                { value: "SENT TO LOAD", label: "PROCEED TO LOAD" },
                {
                  value: "SENT FOR WEIGHBRIDGE",
                  label: "PROCEED TO WEIGHBRIDGE",
                },
              ]}
            ></Select>

            {proceedToState === "PROCEED TO WEIGHBRIDGE" && (
              <>
                <p className="text-red-600 lg:ml-2">WeighBridge :</p>
                <Select
                  className="lg:w-48 lg:ml-4"
                  menuPortalTarget={document.body} // ⬅️ Renders dropdown at body level
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ⬅️ Forces on top
                  }}
                  value={
                    wbName
                      ? { value: wbName, label: wbName }
                      : { value: "", label: "Select WeighBridge" }
                  }
                  onChange={(e) => {
                    if (e.value !== "") {
                      setWbName(e.label);
                      setWbNo(e.value);
                      const weigh = WeighBridgeData?.filter(
                        (item) => item?.WEIGHBRIDGENO === e.value,
                      );
                      setNoOfVehicles(weigh?.length);
                    }
                  }}
                  options={[
                    { value: "", label: "Select WeighBridge" },
                    ...wbData?.map((item) => ({
                      value: item.WBNUMBER,
                      label: item.WBNAME,
                    })),
                  ]}
                ></Select>
                <p className="text-red-600 lg:ml-2">No Of Vehicles :</p>
                <input
                  className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="number"
                  value={noOfVehicles}
                  readOnly
                ></input>
              </>
            )}
          </div>

          {/* Table (Auto-loads all products) */}
          <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
            <div className="flex">
              <p>Search :</p>
              <input
                className="w-48 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                type="text"
                value={searchChild}
                onChange={(e) => setSearchChild(e.target.value)}
              ></input>

              <p className="lg:ml-2">Product :</p>
              <Select
                className="lg:w-96 lg:ml-2"
                value={
                  selProduct
                    ? {
                        value: selProduct,
                        label: selProduct,
                      }
                    : { value: "", label: "Select Product" }
                }
                onChange={(e) => setSelProduct(e.value)}
                options={[
                  { value: "", label: "Select Product" },
                  ...productsList?.map((item) => ({
                    value: item.MAINNAME,
                    label: item.MAINNAME,
                  })),
                ]}
              />
            </div>
            <table className="w-full border border-gray-300 text-sm">
              <thead className="sticky top-0">
                <tr className="bg-[#2b3f5c] text-white text-[12px]">
                  <td className="py-2 px-4 text-center border border-gray-300">
                    ✔
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    SNO
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    PRODUCT
                  </td>
                  {/* <td className="py-2 px-4 text-left border border-gray-300">
                    SPECIFICATIONS
                  </td> */}
                  <td className="py-2 px-4 text-left border border-gray-300">
                    QUANTITY
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    UOM
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    ACTION
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    REASON
                  </td>
                </tr>
              </thead>

              <tbody>
                {filtProd?.map((prod, index) => {
                  const rowData = tableData.find(
                    (r) => String(r.ITEMCODE) === String(prod.ITEMCODE),
                  );
                  return (
                    <tr
                      key={prod.ITEMCODE}
                      className="hover:bg-gray-100 text-[13px]"
                    >
                      {/* CHECKBOX */}
                      <td className="py-2 px-4 text-center border border-gray-300">
                        <input
                          type="checkbox"
                          // checked={tableData[index]?.isSelected || false}
                          // checked={
                          //   tableData.find((r) => r.ITEMCODE === prod.ITEMCODE)
                          //     ?.isSelected || false
                          // }

                          //   checked={rowData?.isSelected || false}
                          // onChange={(e) =>
                          //   handleRowCheck(prod.ITEMCODE, e.target.checked)
                          // }
                          checked={rowData?.isSelected ?? false}
                          onChange={(e) =>
                            updateTableField(
                              prod.ITEMCODE,
                              "isSelected",
                              e.target.checked,
                            )
                          }
                        />
                      </td>

                      {/* SNO */}
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {index + 1}
                      </td>

                      {/* PRODUCT NAME */}
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {prod.MAINNAME}
                      </td>

                      {/* UOM INPUT */}
                      {/* <td className="py-2 px-4 text-left border border-gray-300">
                      {prod?.SPECIFICATIONS || ""}
                    </td> */}

                      {/* QUANTITY INPUT */}
                      <td className="py-2 px-4 text-left border border-gray-300">
                        <input
                          type="number"
                          className="w-24 h-7 border border-black text-right p-1 rounded-md"
                          // value={tableData[index]?.qty || ""}
                          value={
                            tableData.find((r) => r.ITEMCODE === prod.ITEMCODE)
                              ?.qty || ""
                          }
                          onChange={(e) =>
                            updateTableField(
                              prod.ITEMCODE,
                              "qty",
                              e.target.value,
                            )
                          }
                        />
                      </td>

                      <td className="py-2 px-4 text-left border border-gray-300">
                        <Select
                          className="lg:w-48 w-48 lg:ml-7"
                          // value={
                          //   tableData[index]?.uom
                          //     ? {
                          //         value: tableData[index].uom,
                          //         label: tableData[index].uom,
                          //       }
                          //     : { value: "", label: "Select UOM" }
                          // }

                          value={
                            tableData.find((r) => r.ITEMCODE === prod.ITEMCODE)
                              ?.uom
                              ? {
                                  value: tableData.find(
                                    (r) => r.ITEMCODE === prod.ITEMCODE,
                                  ).uom,
                                  label: tableData.find(
                                    (r) => r.ITEMCODE === prod.ITEMCODE,
                                  ).uom,
                                }
                              : { value: "", label: "Select UOM" }
                          }
                          onChange={(e) =>
                            // updateTableField(index, "uom", e.value)
                            updateTableField(prod.ITEMCODE, "uom", e.value)
                          }
                          options={[
                            { value: "", label: "Select UOM" },
                            ...uomList?.map((item) => ({
                              value: item.OM_UOM_CODE,
                              label: item.OM_UOM_CODE,
                            })),
                          ]}
                        />
                      </td>

                      {/* MILL SELECT */}
                      <td className="py-2 px-4 text-left border border-gray-300">
                        <Select
                          className="lg:w-48 w-48 lg:ml-7"
                          // value={
                          //   tableData[index]?.actionTaken
                          //     ? {
                          //         value: tableData[index].actionTaken,
                          //         label: tableData[index].actionTaken,
                          //       }
                          //     : { value: "", label: "Select Action Taken" }
                          // }

                          value={
                            tableData.find((r) => r.ITEMCODE === prod.ITEMCODE)
                              ?.actionTaken
                              ? {
                                  value: tableData.find(
                                    (r) => r.ITEMCODE === prod.ITEMCODE,
                                  ).actionTaken,
                                  label: tableData.find(
                                    (r) => r.ITEMCODE === prod.ITEMCODE,
                                  ).actionTaken,
                                }
                              : { value: "", label: "Select Action Taken" }
                          }
                          onChange={(e) =>
                            // updateTableField(index, "actionTaken", e.value)
                            updateTableField(
                              prod.ITEMCODE,
                              "actionTaken",
                              e.value,
                            )
                          }
                          options={[
                            { value: "", label: "Select Action Taken" },
                            ...returnActionData?.map((item) => ({
                              value: item.OM_ACTION_DESCRIPTION,
                              label: item.OM_ACTION_DESCRIPTION,
                            })),
                          ]}
                          // options={[
                          //   { value: "", label: "Select Action Taken" },
                          //   { value: "REPACKAGED", label: "REPACKAGED" },
                          //   {
                          //     value: "SENT TO ANIMAL FEEDS",
                          //     label: "SENT TO ANIMAL FEEDS",
                          //   },
                          //   { value: "DISPOSED", label: "DISPOSED" },
                          // ]}
                        />
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        <Select
                          className="lg:w-48 w-48 lg:ml-7"
                          // value={
                          //   tableData[index]?.reason
                          //     ? {
                          //         value: tableData[index].reason,
                          //         label: tableData[index].reason,
                          //       }
                          //     : { value: "", label: "Select Reason" }
                          // }

                          value={
                            tableData.find((r) => r.ITEMCODE === prod.ITEMCODE)
                              ?.reason
                              ? {
                                  value: tableData.find(
                                    (r) => r.ITEMCODE === prod.ITEMCODE,
                                  ).reason,
                                  label: tableData.find(
                                    (r) => r.ITEMCODE === prod.ITEMCODE,
                                  ).reason,
                                }
                              : { value: "", label: "Select Reason" }
                          }
                          onChange={(e) =>
                            // updateTableField(index, "reason", e.value)
                            updateTableField(prod.ITEMCODE, "reason", e.value)
                          }
                          options={[
                            { value: "", label: "Select Reason" },
                            ...returnReasonData?.map((item) => ({
                              value: item.OM_REASON_DESCRIPTION,
                              label: item.OM_REASON_DESCRIPTION,
                            })),
                          ]}
                        />
                        {/* <textarea
                        rows={2}
                        className="resize-none w-80 h-12 border border-black p-1 rounded-md"
                        value={tableData[index]?.reason || ""}
                        onChange={(e) =>
                          updateTableField(index, "reason", e.target.value)
                        }
                      /> */}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <button
            className="absolute top-2 right-20  lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={async () => {
              if (!driverCode) {
                alert("Kindly Supply Driver");
                return;
              }

              if (!proceedToState) {
                alert("Kindly Supply Proceed To");
                return;
              }

              if (proceedToState === "PROCEED TO WEIGHBRIDGE" && !wbName) {
                alert("Kindly Supply Weighbridge No");
                return;
              }

              const selectedRows = tableData?.filter((row) => row.isSelected);

              if (selectedRows.length === 0) {
                alert("Kindly select at least one product");
                return;
              }

              for (const row of tableData) {
                if (row?.isSelected) {
                  if (
                    !row?.qty ||
                    !row?.uom ||
                    !row?.actionTaken ||
                    !row?.reason
                  ) {
                    alert(
                      `Qty, UOM, Action Taken and Reason are mandatory for product: ${row.code}`,
                    );
                    return;
                  }
                }
              }
              await SaveHeader();
              setShowGateIn(false);
              window.location.reload();
            }}
          >
            RETURN
          </button>

          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIn(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default VehiclesToComeToReturns;
